"use strict";

$(document).on(Fotobook.events.PROJECT_INFO_CHANGED, function(event, project){
    var calendar = Fotobook.containers.calendar;

    $(document.documentElement)
        .toggleClass("show-holiday-titles-bottom", project.show_holiday_titles === calendar.SHOW_HOLIDAYS_TITLE_BOTTOM)
        .toggleClass("show-holiday-titles-top", project.show_holiday_titles === calendar.SHOW_HOLIDAYS_TITLE_TOP);
});
